import createOperation from "../createOperation";
import slice from "./slice";
import newsService from "../../services/news.service";

const { actions } = slice;

export const fetchNews = createOperation({
  actions: {
    successAction: actions.fetchNewsSuccess,
  },

  async process(params: any) {
    return await newsService.fetchNews(params?.payload);
  },
});

export const fetchNewsDetail = createOperation({
  actions: {
    successAction: actions.fetchNewsDetailSuccess,
  },

  async process(params: any) {
    return await newsService.fetchNewsDetail(params?.payload);
  },
});
